"use strict";

var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  Object.defineProperty(o, k2, {
    enumerable: true,
    get: function get() {
      return m[k];
    }
  });
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});
var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});
var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  }
  __setModuleDefault(result, mod);
  return result;
};
var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }
  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }
    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }
    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }
    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};
var __generator = this && this.__generator || function (thisArg, body) {
  var _ = {
      label: 0,
      sent: function sent() {
        if (t[0] & 1) throw t[1];
        return t[1];
      },
      trys: [],
      ops: []
    },
    f,
    y,
    t,
    g;
  return g = {
    next: verb(0),
    "throw": verb(1),
    "return": verb(2)
  }, typeof Symbol === "function" && (g[Symbol.iterator] = function () {
    return this;
  }), g;
  function verb(n) {
    return function (v) {
      return step([n, v]);
    };
  }
  function step(op) {
    if (f) throw new TypeError("Generator is already executing.");
    while (_) {
      try {
        if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
        if (y = 0, t) op = [op[0] & 2, t.value];
        switch (op[0]) {
          case 0:
          case 1:
            t = op;
            break;
          case 4:
            _.label++;
            return {
              value: op[1],
              done: false
            };
          case 5:
            _.label++;
            y = op[1];
            op = [0];
            continue;
          case 7:
            op = _.ops.pop();
            _.trys.pop();
            continue;
          default:
            if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
              _ = 0;
              continue;
            }
            if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
              _.label = op[1];
              break;
            }
            if (op[0] === 6 && _.label < t[1]) {
              _.label = t[1];
              t = op;
              break;
            }
            if (t && _.label < t[2]) {
              _.label = t[2];
              _.ops.push(op);
              break;
            }
            if (t[2]) _.ops.pop();
            _.trys.pop();
            continue;
        }
        op = body.call(thisArg, _);
      } catch (e) {
        op = [6, e];
        y = 0;
      } finally {
        f = t = 0;
      }
    }
    if (op[0] & 5) throw op[1];
    return {
      value: op[0] ? op[1] : void 0,
      done: true
    };
  }
};
var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CartList = void 0;
var react_1 = __importDefault(require("react"));
var styled_components_1 = __importDefault(require("styled-components"));
var reconnect_js_1 = require("reconnect.js");
var Cart = __importStar(require("../../Actions/Cart"));
var Tracker_1 = __importDefault(require("../../Utils/Tracker"));
var ItemInCart_1 = __importDefault(require("./ItemInCart"));
var ChevronDown_1 = require("@styled-icons/boxicons-regular/ChevronDown");
function CartList(props) {
  var _this = this;
  var cartItems = props.cartItems,
    _a = props.disabled,
    disabled = _a === void 0 ? false : _a,
    _b = props.defaultExpand,
    defaultExpand = _b === void 0 ? true : _b;
  var _c = react_1.default.useState(defaultExpand),
    expand = _c[0],
    setExpand = _c[1];
  var AppActions = reconnect_js_1.useOutlet('actions')[0];
  var dataSource = cartItems.map(function (c, i) {
    return __assign(__assign({}, c), {
      index: i
    });
  });
  var editCartItem = function editCartItem(index, config) {
    return __awaiter(_this, void 0, void 0, function () {
      var ex_1;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            AppActions.setLoading(true);
            _a.label = 1;
          case 1:
            _a.trys.push([1, 3,, 4]);
            return [4 /*yield*/, Cart.editItemInCart(index, config)];
          case 2:
            _a.sent();
            return [3 /*break*/, 4];
          case 3:
            ex_1 = _a.sent();
            console.warn(ex_1);
            return [3 /*break*/, 4];
          case 4:
            AppActions.setLoading(false);
            return [2 /*return*/];
        }
      });
    });
  };

  var removeFromCart = function removeFromCart(index) {
    return __awaiter(_this, void 0, void 0, function () {
      var targetItem;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            _a.trys.push([0,, 2, 3]);
            AppActions.setLoading(true);
            targetItem = dataSource.find(function (item) {
              return item.index === index;
            });
            return [4 /*yield*/, Cart.removeFromCart(index)];
          case 1:
            _a.sent();
            Tracker_1.default.removeFromCart({
              cartItem: targetItem
            });
            return [3 /*break*/, 3];
          case 2:
            AppActions.setLoading(false);
            return [7 /*endfinally*/];
          case 3:
            return [2 /*return*/];
        }
      });
    });
  };

  if (props.cartListCustomRenderer) {
    return props.cartListCustomRenderer({
      cartItems: cartItems,
      disabled: disabled,
      editCartItem: editCartItem,
      removeFromCart: removeFromCart
    });
  }
  return react_1.default.createElement(Wrapper, {
    className: "rev-CartList",
    expand: expand
  }, react_1.default.createElement("div", {
    className: "cart-header"
  }, react_1.default.createElement("h2", null, AppActions.L('cart_items')), react_1.default.createElement("div", {
    className: "items",
    onClick: function onClick() {
      return setExpand(!expand);
    }
  }, react_1.default.createElement("div", null, (cartItems === null || cartItems === void 0 ? void 0 : cartItems.length) || 0, " ", AppActions.L('pieces_of_item')), react_1.default.createElement(ChevronDown_1.ChevronDown, {
    size: 24,
    color: "#aaa"
  }))), react_1.default.createElement("div", {
    className: "cart-items-table"
  }, react_1.default.createElement("div", {
    className: "table-header"
  }, react_1.default.createElement("div", {
    className: "product"
  }, AppActions.L('item')), react_1.default.createElement("div", {
    className: "variants"
  }, AppActions.L('spec')), react_1.default.createElement("div", {
    className: "price"
  }, AppActions.L('subtotal')), react_1.default.createElement("div", {
    className: "remove"
  }, " ")), dataSource.map(function (item, index) {
    return react_1.default.createElement(react_1.default.Fragment, null, react_1.default.createElement(ItemInCart_1.default, {
      key: item.random,
      index: index,
      item: item,
      editCartItem: editCartItem,
      removeFromCart: removeFromCart,
      disabled: disabled,
      customRenderer: props.cartItemCustomRenderer
    }));
  })));
}
exports.CartList = CartList;
var Wrapper = styled_components_1.default.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  width: 100%;\n  overflow-x: auto;\n  overflow-y: hidden;\n  padding: ", ";\n  background-color: white;\n  border-radius: 6px;\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.3);\n\n  & > .cart-header {\n    padding: 10px 0;\n    display: flex;\n    align-items: center;\n\n    & > h2 {\n      flex: 1;\n      font-size: 1.33rem;\n    }\n\n    & > .items {\n      display: flex;\n      align-items: center;\n      font-size: 1rem;\n      cursor: pointer;\n\n      & > :last-child {\n        transform: rotateX(", ");\n        transition: all 200ms;\n      }\n    }\n  }\n\n  & > .cart-items-table {\n    max-height: ", ";\n    opacity: ", ";\n    transition: all 200ms;\n\n    & > div.table-header {\n      display: flex;\n      color: #aaa;\n\n      & > * {\n        padding: 8px 0px;\n        border-top: 1px solid #aaa;\n        border-bottom: 1px solid #aaa;\n      }\n\n      & > .product {\n        flex: 1 0 300px;\n      }\n\n      & > .variants {\n        flex: 0 0 150px;\n      }\n\n      & > .price {\n        flex: 0 0 100px;\n      }\n\n      & > .remove {\n        flex: 0 0 50px;\n      }\n    }\n  }\n\n  @media (max-width: 800px) {\n    & > .cart-header {\n      border-bottom: 1px solid #aaa;\n    }\n\n    & > .cart-items-table {\n      & > div.table-header {\n        display: none;\n      }\n    }\n  }\n"], ["\n  width: 100%;\n  overflow-x: auto;\n  overflow-y: hidden;\n  padding: ", ";\n  background-color: white;\n  border-radius: 6px;\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.3);\n\n  & > .cart-header {\n    padding: 10px 0;\n    display: flex;\n    align-items: center;\n\n    & > h2 {\n      flex: 1;\n      font-size: 1.33rem;\n    }\n\n    & > .items {\n      display: flex;\n      align-items: center;\n      font-size: 1rem;\n      cursor: pointer;\n\n      & > :last-child {\n        transform: rotateX(", ");\n        transition: all 200ms;\n      }\n    }\n  }\n\n  & > .cart-items-table {\n    max-height: ", ";\n    opacity: ", ";\n    transition: all 200ms;\n\n    & > div.table-header {\n      display: flex;\n      color: #aaa;\n\n      & > * {\n        padding: 8px 0px;\n        border-top: 1px solid #aaa;\n        border-bottom: 1px solid #aaa;\n      }\n\n      & > .product {\n        flex: 1 0 300px;\n      }\n\n      & > .variants {\n        flex: 0 0 150px;\n      }\n\n      & > .price {\n        flex: 0 0 100px;\n      }\n\n      & > .remove {\n        flex: 0 0 50px;\n      }\n    }\n  }\n\n  @media (max-width: 800px) {\n    & > .cart-header {\n      border-bottom: 1px solid #aaa;\n    }\n\n    & > .cart-items-table {\n      & > div.table-header {\n        display: none;\n      }\n    }\n  }\n"])), function (props) {
  return props.expand ? '0 10px 10px 10px' : '0 10px';
}, function (props) {
  return props.expand ? '0deg' : '180deg';
}, function (props) {
  return props.expand ? 'unset' : '0px';
}, function (props) {
  return props.expand ? 1 : 0;
});
exports.default = CartList;
var templateObject_1;